var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClosePlan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9163 10.1474C11.8771 10.1083 11.8551 10.0552 11.8551 9.99986C11.8551 9.94452 11.8771 9.89145 11.9163 9.85237L19.6352 2.13436C20.1232 1.6456 20.1227 0.853742 19.6339 0.36568C19.1452 -0.122381 18.3533 -0.121822 17.8652 0.36693L10.1472 8.08161C10.1081 8.12079 10.0551 8.14281 9.99972 8.14281C9.94438 8.14281 9.89131 8.12079 9.85223 8.08161L2.13421 0.36693C1.64615 -0.121361 0.854661 -0.121548 0.366369 0.366514C-0.121922 0.854575 -0.122109 1.64607 0.365952 2.13436L8.08313 9.85237C8.12231 9.89145 8.14434 9.94452 8.14434 9.99986C8.14434 10.0552 8.12231 10.1083 8.08313 10.1474L0.365952 17.8662C0.0502321 18.1821 -0.0729913 18.6424 0.0426993 19.0737C0.15839 19.5051 0.495418 19.842 0.926829 19.9575C1.35824 20.0729 1.81849 19.9495 2.13421 19.6336L9.85223 11.9148C9.89131 11.8756 9.94438 11.8536 9.99972 11.8536C10.0551 11.8536 10.1081 11.8756 10.1472 11.9148L17.8652 19.6336C18.3533 20.1219 19.1448 20.1221 19.6331 19.634C20.1214 19.146 20.1215 18.3545 19.6335 17.8662L11.9163 10.1474Z",
    fill: "#FF0000",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClosePlan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-plan.2f67a7a2.svg";
export { ForwardRef as ReactComponent };